import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import InnerLoader from './../../APP/COMPONENTS/InnerLoader';
import * as helpers from "./../../APP/HELPERS/functions"

function mapStateToProps(state) {
    return {
        USER: state.USER
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class Header extends Component {

    /// CONSTRUCTOR ///
    constructor(props)
    {
        super(props);
        this.state = {
            OPENED: false
        }

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setNavRef = this.setNavRef.bind(this);
        this.setNavLinkRef = this.setNavLinkRef.bind(this);
    }

    componentDidMount()
    {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setNavRef(node) {
        this.nav = node;
    }

    setNavLinkRef(node) {
        this.navlink = node;
    }

    handleClickOutside(event) {
        if (this.nav && !this.nav.contains(event.target) && !this.navlink.contains(event.target)) {
            if (this.state.OPENED) {
                this.setState({OPENED: false});
            }
        }
    }

    avatarChosen = async (e) =>
    {
        let file = e.target.files[0];

        if (typeof file !== "undefined") {
            if (file !== null) {
                let SEND_DATA = new FormData();

                SEND_DATA.append('action', 'uploadSupplierAvatar');
                SEND_DATA.append('supplier_apikey', this.props.USER.supplier_apikey);
                SEND_DATA.append('PICTURE', file);

                fetch( 
                    CONFIG.API_GATE, 
                    {
                        credentials: 'include',
                        method: "POST",
                        body: SEND_DATA
                    }
                )
                .then((response) => response.json())
                .then((responseJson) => {
                    if (responseJson.status.result == 'SUCCESS') {
                        let USER = Object.assign({}, this.props.USER);
                        USER.image = responseJson.data.image;
                        this.props.doAuth(USER);
                    }
                })
                .catch(err => {
                })
            }
        }
    }

    toggleMenu = () =>
    {
        let OPENED = true;
        if (this.state.OPENED) {
            OPENED = false;
        }

        this.setState({OPENED: OPENED});
    }

    getHolderClass = () =>
    {
        if (this.state.OPENED) {
            return ' opened';
        }

        return '';
    }

    renderSubNav = () =>
    {
        return (
            <div className="header_drop_nav" ref={this.setNavRef}>
                <a>Профиль</a>
                <a>Компания</a>
                <div className="header_drop_nav_spacer"></div>
                <a onClick={() => this.props.logOut()}>
                    <img src="/system_images/logout.png" />Выход
                </a>
            </div>
        );
    }

    getAvatarSource(USER)
    {
        let SOURCE = '/system_images/no_user_pic.png';

        if (USER.image !== "") {
            SOURCE = CONFIG.API_C_DOMAIN + USER.image;
        }

        return SOURCE;
    }

    renderAvatar = () =>
    {
        let IMAGE = this.getAvatarSource(this.props.USER);

        return (
            <label className="user_avatar_holder">
                <div className="user_avatar">
                    <div className="user_avatar_image" style={{'background': 'transparent url(' + IMAGE + ')'}}></div>
                </div>
                <input style={{'display':'none'}} type="file" onChange={(e)=>this.avatarChosen(e)} />
            </label>
        );
    }

    renderRate = () =>
    {
        if (this.props.USER.rate > 0) {
            return (
                <div className="header_rate">
                    <img src="/system_images/star.png" />
                    <span>
                        Рейтинг {this.props.USER.rate}
                    </span>
                </div>
            )
        }
    }

    render()
    {
        return (
            <div className="header_holder">
                <div className="page_header">

                    <div className="header_title">
                        {this.props.USER.title}
                        {this.renderRate()}
                    </div>
                    

                    <div className="header_right">
                        <div className={'header_right_title_holder' + this.getHolderClass()}>
                            <a className="header_right_init" onClick={() => this.toggleMenu()} ref={this.setNavLinkRef}>
                                <div className="header_right_title">
                                    {this.props.USER.title}
                                </div>
                                <span>
                                    <img src="/system_images/angle.png" />
                                </span>
                            </a>
                            {this.renderSubNav()}
                        </div>
                        {this.renderAvatar()}
                    </div>

                </div>
            </div>
        );
    }

}

export default connect(
    mapStateToProps, mapDispatchToProps
)(Header);